import { QueryHookOptions, gql } from '@apollo/client'
import { usePersistedCacheQuery } from 'app/hooks'

const query = gql`
  query fetchBrandOffers($brand: String!, $page: Int!, $limit: Int!, $dedupeIds: [String!]) {
    fetchOffers(brand: $brand, page: $page, limit: $limit, dedupeIds: $dedupeIds) {
      totalDocs
      page
      totalPages
      docs {
        id
        name
        description
        tag
        brand {
          id
          slug
        }
        thumbnailImage {
          id
          url
        }
        slug
        redeemInList
        canRedeem
        offerLinkLabel
        usesCodes
      }
    }
  }
`

export interface BrandOffersQueryInput {
  brand: string
  dedupeIds?: string[]
  page: number
  limit: number
}

export interface BrandOffersQueryOutput {
  fetchOffers: {
    totalDocs: number
    page: number
    totalPages: number
    docs: {
      id: string
      name: string
      description: string
      tag: string
      brand: {
        id: string
        name: string
        logo: {
          url: string
        }
        slug: string
      }
      thumbnailImage: {
        url: string
      }
      slug: string
      redeemInList: boolean
      canRedeem: boolean
      offerLinkLabel: string
      usesCodes: boolean
    }[]
  }
}

export const useBrandOffersQuery = (
  options?: QueryHookOptions<BrandOffersQueryOutput, BrandOffersQueryInput>
) =>
  usePersistedCacheQuery<BrandOffersQueryOutput, BrandOffersQueryInput>(
    query,
    {
      ...options,
    }
  )

export const fetchBrandOffersQuery = { query }
